var moduleMap = {
	"./constants": () => {
		return __webpack_require__.e(934).then(() => (() => ((__webpack_require__(9934)))));
	},
	"./axiosClient": () => {
		return Promise.all([__webpack_require__.e(651), __webpack_require__.e(644), __webpack_require__.e(600)]).then(() => (() => ((__webpack_require__(6600)))));
	},
	"./baseCrud": () => {
		return Promise.all([__webpack_require__.e(651), __webpack_require__.e(644), __webpack_require__.e(65)]).then(() => (() => ((__webpack_require__(7065)))));
	},
	"./authenticator": () => {
		return Promise.all([__webpack_require__.e(651), __webpack_require__.e(644), __webpack_require__.e(326)]).then(() => (() => ((__webpack_require__(6326)))));
	},
	"./analytics": () => {
		return Promise.all([__webpack_require__.e(383), __webpack_require__.e(796)]).then(() => (() => ((__webpack_require__(9255)))));
	},
	"./tracking": () => {
		return Promise.all([__webpack_require__.e(651), __webpack_require__.e(924), __webpack_require__.e(825)]).then(() => (() => ((__webpack_require__(9825)))));
	},
	"./authentication": () => {
		return Promise.all([__webpack_require__.e(651), __webpack_require__.e(829)]).then(() => (() => ((__webpack_require__(5829)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(651), __webpack_require__.e(727)]).then(() => (() => ((__webpack_require__(4727)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});